import React from 'react';
import * as MuiCore from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';

const GreetingCard = ({ 
    greeting, 
    editing, 
    tempValue,
    onEdit, 
    onSave, 
    onCancel, 
    onChange,
    error,
    classes 
}) => {
    return (
        <MuiCore.Box className={classes.section}>
            <MuiCore.Box className={classes.sectionHeader}>
                <MuiCore.Box className={classes.sectionTitle}>
                    <MuiCore.SvgIcon>
                        <path d="M12 14c1.66 0 2.99-1.34 2.99-3L15 5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3zm5.3-3c0 3-2.54 5.1-5.3 5.1S6.7 14 6.7 11H5c0 3.41 2.72 6.23 6 6.72V21h2v-3.28c3.28-.48 6-3.3 6-6.72h-1.7z"/>
                    </MuiCore.SvgIcon>
                    <MuiCore.Typography variant="h6" style={{ fontFamily: 'Sofia-bold' }}>Greeting</MuiCore.Typography>
                </MuiCore.Box>
                {!editing && (
                    <MuiCore.Button
                        startIcon={<EditIcon />}
                        className={classes.editButton}
                        variant="outlined"
                        onClick={onEdit}
                    >
                        EDIT
                    </MuiCore.Button>
                )}
            </MuiCore.Box>
            <MuiCore.Typography variant="body2" color="textSecondary" style={{ marginBottom: 16, fontFamily: 'Sofia' }}>
                Your Grasshopper AI will read this custom answer phrase immediately after the standard disclosure statement
            </MuiCore.Typography>
            {editing ? (
                <>
                    <MuiCore.TextField
                        label="Answer Phrase"
                        multiline
                        rows={3}
                        value={tempValue}
                        onChange={(e) => onChange(e.target.value)}
                        className={classes.textField}
                        variant="outlined"
                        placeholder='Please enter a custom greeting for your Grasshopper AI to say to the callers.'
                        error={!!error}
                        helperText={error || ''}
                        inputProps={{ maxLength: 500, style: { fontFamily: 'Sofia' } }}
                        InputLabelProps={{ style: { fontFamily: 'Sofia' } }}
                        InputProps={{ style: { fontFamily: 'Sofia' } }}
                    />
                    <MuiCore.Typography 
                        variant="caption" 
                        style={{ 
                            display: 'block', 
                            textAlign: 'right', 
                            marginTop: 4, 
                            color: tempValue.length > 500 ? '#d32f2f' : '#666',
                            fontFamily: 'Sofia'
                        }}
                    >
                        {tempValue.length}/500 Characters
                    </MuiCore.Typography>
                    <MuiCore.Box className={classes.actionButtons}>
                        <MuiCore.Button
                            startIcon={<CloseIcon />}
                            onClick={onCancel}
                            variant="outlined"
                            style={{ fontFamily: 'Sofia', textTransform: 'none', borderRadius: 100 }}
                        >
                            Cancel
                        </MuiCore.Button>
                        <MuiCore.Button
                            startIcon={<CheckIcon />}
                            onClick={onSave}
                            variant="contained"
                            style={{ backgroundColor: '#7F2062', color: '#fff', fontFamily: 'Sofia', fontWeight: 700, textTransform: 'none', borderRadius: 100 }}
                        >
                            Save
                        </MuiCore.Button>
                    </MuiCore.Box>
                </>
            ) : (
                <MuiCore.Typography style={{ fontFamily: 'Sofia', fontStyle: 'italic' }}>
                    {greeting || 'No greeting set'}
                </MuiCore.Typography>
            )}
        </MuiCore.Box>
    );
};

export default GreetingCard;
